<template>

  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="goMore('/finance/index','首页')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>金融机构</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <!-- <div class="serch_border" v-if="options">
    <div class="serchform">
      投资额度：
      <a-tag :class="{'tag-active':''==invest_limits}"  @click="postSerchData({'invest_limit':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==invest_limits}"  @click="postSerchData({'invest_limit':item.dictValue})" v-for="(item,key) in options.invest_limit" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border" v-if="options">
    <div class="serchform">
      投资领域：
      <a-tag :class="{'tag-active':''==investmentFields}"  @click="postSerchData({'investmentField':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==investmentFields}"  @click="postSerchData({'investmentField':item.dictValue})" v-for="(item,key) in options.investmentField" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border" v-if="options">
    <div class="serchform">
      投资阶段：
      <a-tag :class="{'tag-active':''==projectStages}"  @click="postSerchData({'projectStage':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==projectStages}"  @click="postSerchData({'projectStage':item.dictValue})" v-for="(item,key) in options.projectStage" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div> -->
  <div class="cont_body">
    <div v-for="(item,key) in dataSource" :key="key" class="list_cont flex-cl" @click="goMore('/finance/institution/page','金融机构',item.id)">
      <div class="img">
        <img v-if="item.logo" :src="getImg(item.logo)" alt="">
        <img v-else src="@/assets/img/defaultPhoto.png" alt="">
      </div>
      <h3>{{item.name}}</h3>
      <p class="text">{{item.briefIntroduction}}</p>
      <p class="tag">联系电话：{{item.telephone}}</p>
      <!-- <p class="tag"><dict-render :dict-obj="dictObjs['investmentField']"
        :text="item.investmentField"></dict-render></p> -->
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</template>
<script>
import {
  dictMixin,
  listMixin } from "@/mixins";
import {financeInstitutionWeb} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
// import DictRender from "@/components/other/DictRender";
import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: {
    // DictRender
   },
  mixins: [dictMixin, listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 查询条件
      invest_limits: '',// 投资额度
      investmentFields: '',// 投资领域
      projectStages: '', //投资阶段
      dictNames: 'investmentField,position,invest_limit,projectStage',
      listUrl: financeInstitutionWeb.pageList,
      queryParamFixed: {
        investmentField: '',
              investmentStage: '',
              quota: ''
       },
      financeDict,
      options:null,
      current: 1,
      pageSize: 12,
    }
  },
  mounted() {
      this.getDict();
  },
	methods: {
    postSerchData(val){
      if(val){
          if(val.invest_limit||val.invest_limit==''){
            this.queryParamFixed.quota = val.invest_limit
            this.invest_limits = val.invest_limit
          }
          if(val.investmentField||val.investmentField==''){
            this.queryParamFixed.investmentField = val.investmentField
            this.investmentFields = val.investmentField
          }
          if(val.projectStage||val.projectStage==''){
            this.queryParamFixed.projectStages = val.projectStage
            this.projectStages = val.projectStage
          }
          this.loadData()
      }

    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "invest_limit,investmentField,projectStage"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 288px;
  margin-right:16px;
  margin-bottom:16px;
  padding: 25px 15px;
  &:nth-child(4n){
    margin-right: 0;
  }
  .img{
    border:1px solid #eeeeee;
    width: 100px;
    height:100px;
    display: flex;
    align-items: center;
    justify-content:center;
    img{
      height:100%;
    }
  }
  h3{
    font-size: 20px;
    line-height: 60px;
    margin-bottom: 20px;
    text-align: center;
    word-break: break-all;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
  }
  p{
    font-size: 16px;
  }
  .text{
    width:100%;
    height: 75px;
    text-align: left;
    word-break: break-all;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:3;
  }
  .tag{
    text-align: left;
    margin-top: 25px;
    width: 100%;
    color:#cccccc;
  }

}
</style>
